
<template>
  <div
    class="table_r w-full justify-start items-center text-[var(--text)] gap-2 p-4 bg-[--fundoForm] rounded-[10px] bg-opacity-[0.55] flex flex-col overflow-x-hidden"
    :style="{
      height: '100%',
      paddingTop: styled.noPaddingTop ? '1em' : '2rem',
    }"
    v-if="show && visibility"
  >
    <div class="title_table w-full ">
      <div class="title_settings">
        <div class="table_title capitalize" style="display: flex; gap: 1em">
          {{ table_title }}
        </div>
        <AppSearch :focused="simple" :styled="styled" @search="getSearch" />
        <div class="close_btn_div">
          <button v-if="btn_adicionar" class="btn" @click="criarServico">
            <i class="fa-solid fa-circle-plus fa-2xl" style="color: #ffff"></i>
            <div style="white-space: nowrap">Serviço</div>
          </button>
          <button v-if="btn_adicionar" class="btn" @click="criarObservacao">
            <i class="fas fa-sticky-note fa-2xl" style="color: #ffff"></i>
            <div style="white-space: nowrap">Observações</div>
          </button>

          <div style="display: flex; gap: 0.5rem">
            <span v-if="!simple">registos:</span>
            <select
              v-model="perPage"
              style="
                color: var(--icon);
                border-radius: 0.5rem;
                background-color: var(--fundoApp);
              "
            >
              <option v-for="option in perPageOptions" :value="option">
                {{ option }}
              </option>
            </select>
          </div>
          <AppTableFilter
            v-if="!simple"
            :filter_data="filter_data"
            @update-filter="updateFilter"
          />
          <input
            v-if="multiSelect.show"
            type="checkbox"
            v-model="isMultiSelect"
          />
          {{ !simple ? (multiSelect.show ? "Multi-Select" : "") : null }}
          <!-- make an add buton -->
          <div
            v-for="btn in multiSelect.buttons"
            v-if="multiSelect.show && isMultiSelect"
          >
            <button
              :disabled="!btn.enabled"
              v-if="btn.show"
              @click="sendSelectedRows(btn.emit)"
              class="btn"
              :style="{ backgroundColor: btn.enabled ? btn.color : 'gray' }"
            >
              <i :class="btn.icon" style="color: #ffff"></i>
              <div style="white-space: nowrap">{{ btn.text }}</div>
             </button>

           </div>
         
          <AppButton
            v-if="!noClose"
            v-bind:visibility="true"
            left_icon="fa-regular fa-circle-xmark fa-xl"
            emitType="close"
            @close="close"
            :width="23"
            :height="23"
          />
        </div>
      </div>
    </div>
    <table class="table-auto w-full md:w-auto sm:w-auto">
      <thead>
        <tr>
          <th
            v-for="header in displayedHeaders"
            :key="header"
           :style="{
            height: aplyRowHeight ? '50px' : '20px', 
              fontSize: aplyRowHeight ? '24px' : '16px',
            }"
          >
            {{ handleTableHeader(header) }}
          </th>
          <th
            v-if="acoesColumn.show"
            :style="{
              height: aplyRowHeight ? '50px' : '20px',
              fontSize: aplyRowHeight ? '24px' : '16px',
              textAlign: 'center',
            }"
          >
            {{ acoesColumn.label || 'Ações' }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(row, rowIndex) in mergedTableData"
          :key="rowIndex"
          @click="
            confirmInclude() && !isMultiSelect
              ? showConfirm($event, row)
              : handleRowClick(row)
          "
          @dblclick="
            confirmInclude() && !isMultiSelect
              ? showConfirm($event, row)
              : handleDoubleClick(row, true)
          "
          :class="{
            selected: isSelectedRow(row),
            nonselected: !isSelectedRow(row),
          }"
          :style="{
            height: aplyRowHeight ? '60px' : '25px',
          }"
        >
          <td
            v-for="header in displayedHeaders"
            :key="header"
            :class="truncateCells ? 'truncate-cell' : 'wrap-cell'"
            :style="{
              backgroundColor: getBackgroundColor(row),
              fontSize: aplyRowHeight ? '18px' : '10px',
            }"

          >
            {{ handleValue(row[header]) }}
          </td>
          <td
            v-if="acoesColumn.show"
            :style="{
              backgroundColor: getBackgroundColor(row),
              fontSize: aplyRowHeight ? '18px' : '10px',
              textAlign: 'center',
            }"
            @click.stop
          >
            <span
              v-for="action in acoesColumn.actions"
              :key="action.emit"
              :title="action.title || ''"
              @click.stop="handleAcaoClick(action.emit, row)"
              style="margin: 0 4px; cursor: pointer;"
            >
              <i :class="action.icon" :style="{ color: action.color || '#ff9b05' }"></i>
            </span>
          </td>
        </tr>

        <div
          v-if="status == '208'"
          style="
            width: 100%;
            text-align: center;
            font-size: 2.5em;
            opacity: 0.5;
          "
        >
          Sem dados
        </div>
        <div
          v-if="status >= 500 && status < 600"
          style="
            background-color: red;
            width: 100%;
            text-align: center;
            font-size: 2.5em;
            opacity: 0.5;
          "
        >
          Erro no servidor
        </div>
      </tbody>
      <PopupPainel
        v-if="status == 0"
        :loading="true"
        :message="'A carregar dados...'"
        :bg="true"
      />
    </table>
    <div class="pagination" style="display: flex; gap: 0.5rem">
      <button
        @click="prevPage"
        :disabled="currentPage === 1"
        style="cursor: pointer; color: #ff9b05"
      >
        <
      </button>
      <span>{{ currentPage }} de {{ totalPages }}</span>
      <button
        @click="nextPage"
        :disabled="currentPage === totalPages"
        style="cursor: pointer; color: #ff9b05"
      >
        >
      </button>
    </div>
  </div>
  <ConfirmPopUp
    ref="myConfirm"
    @accept="onAccept"
    @accept-one="AcceptOne"
    @accept-both="onAcceptBoth"
    :message="confirmationProps.message"
  />
</template>

<script>
import AppButton from "@/components/button.vue";
import AppSearch from "@/components/search.vue";
import AppTableFilter from "@/components/filter/tableFilter.vue";
import ConfirmPopUp from "@/components/modals/MyConfirmPopUp.vue";
import PopupPainel from "@/components/_popupPainel.vue";

export default {
  name: "AppTable",
  components: {
    AppButton,
    AppTableFilter,
    AppSearch,
    ConfirmPopUp,
    PopupPainel,
  },
  props: {
    truncateCells: {
      type: Boolean,
      default: false,
    },
    hiddenHeaders: {
      type: Array,
      default: () => ["id"],
    },
    styled: {
      type: Object,
      default: () => ({}),
    },
    hiden: {
      type: Object,
      default: () => ({
        status: false,
      }),
    },

    noClose: {
      type: Boolean,
      default: () => false,
    },
    specialKey: {
      type: String,
      default: () => null,
    },
    page_display: {
      type: Number,
      default: () => 10,
    },
    simple: {
      type: Boolean,
      default: () => false,
    },
    table_data: {
      type: Array,
      default: () => [],
    },
    btn_criar: {
      type: Object,
      default: () => ({
        show: false,
        form: "0",
      }),
    },
    btn_adicionar: {
      type: Boolean,
      default: () => false,
    },
    status: {
      type: String,
      default: () => 200,
    },
    confirmationProps: {
      type: Object,
      default: () => ({
        show: false,
        message: "Deseja adicionar este item?",
      }),
    },
    table_title: {
      type: String,
      default: () => "Table Title",
    },
    show: {
      type: Boolean,
      default: () => false,
    },
    visibility: {
      type: Boolean,
      default: () => false,
    },
    notificacao: {
      type: Object,
      default: () => ({}),
    },
    styled: {
      type: Object,
      default: () => ({
        fillHeight: false,
        noPaddingTop: false,
      }),
    },
    with_confirmation: {
      type: Boolean,
      default: () => false,
    },
    
    pickKey: {
      type: Array,
      default: () => [],
    },
    applyRowStatusColors: {
      type: Boolean,
      default: false,
    },
    rowStatusData: {
      type: Array,
      default: () => [],
    },
    selectedRowId: {
      type: [Number, String],
      default: null,
    },
    check_codigo_barra: {
      type: Boolean,
      default: false,
    },
    aplyRowHeight: {
      type: Boolean,
      default: false,
    },
    acoesColumn: {
      type: Object,
      default: () => ({
        show: false,
        label: 'Ações',
        actions: [],
      }),
    },
    multiSelect: {
      type: Object,
      default: () => ({
        show: false,
        isActive:false,
        buttons: {
          add: {
            show: false,
            enabled:false,
            text: "Adicionar",
            color: "green",
            icon: "fa-solid fa-plus",
            emit: "send-selected-rows",
          },
          remove: {
            show: false,
            enabled:false,
            text: "Remover",
            color: "red",
            icon: "fa-solid fa-minus",
            emit: "remove-selected-rows",
          },
        },
      }),
    },
  },
  mounted() {
    if (this.selectedRowId !== null) {
      const foundRow = this.table_data.find(
        (row) => row.id == this.selectedRowId
      );
      if (foundRow) {
        this.selectedRow = foundRow;
      }
    }
  },

  data() {
    return {
      filter_data: {},
      search_text: "",
      perPage: this.page_display,
      currentPage: 1,
      selectedRow: {},
      isMultiSelect: this.multiSelect.isActive,
      selectedRows: [],
    };
  },
  watch: {
    table_data: {
      handler(newVal) {
        if (newVal.length > 0) {
          this.filter_data = this.addTrueValues(newVal[0]);
          this.currentPage = 1; // Reset the page to 1 whenever the table data changes
          this.search_text = ""; // Clear the search text whenever the table data changes

          // Update the selected row with the latest data, if it's present.
          if (this.selectedRow && this.selectedRow.id) {
            const updatedRow = newVal.find(
              (row) => row.id === this.selectedRow.id
            );
            if (updatedRow) {
              this.selectedRow = updatedRow;
            }
          }
        }
      },
      immediate: true,
      deep: true,
    },

    search_text() {
      this.currentPage = 1; // Reset the page to 1 whenever the search text changes
    },
    selectedRowId: {
      handler(newId) {
        if (newId !== null) {
          const foundRow = this.table_data.find((row) => row.id == newId);
          if (foundRow) {
            this.selectedRow = foundRow;
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleTableHeader(key) {
      const isCamelCase = /[a-z][A-Z]/.test(key);
      if (isCamelCase) {
        key = key.replace(/([A-Z])/g, " $1").toLowerCase();
      }

      return key;
    },
    openFormCriar() {
      switch (this.btn_criar.form) {
        case "0":
          console.log("Sem form");
          break;
        case "pedido":
          this.$store.state.clientes.formPedidoStatus = true;
          break;
        default:
          break;
      }
    },
    handleValue(value) {
      // console.log('key');
      if (typeof value === "object") {
        if (
          value === null ||
          value === undefined ||
          Object.keys(value).length === 0
        ) {
          return "N/A";
        }
      }
      if (typeof value === "object" && value !== null && value !== undefined) {
        if ("nome" in value) {
          return value.nome;
        } else if ("user" in value) {
          return value.user;
        } else if (this.specialKey != null) {
          return value[this.specialKey];
        } else {
          return value;
        }
      } else {
        return value;
      }
    },

    handleDoubleClick(row, doubleClick = false) {
      this.$emit("row-doClicked", row, doubleClick);
    },

    handleRowClick(row) {
      // Multi-select branch remains unchanged.
      if (this.isMultiSelect) {
        const index = this.selectedRows.findIndex(
          (selected) => selected.id === row.id
        );
        if (index === -1) {
          this.selectedRows.push(row);
        } else {
          this.selectedRows.splice(index, 1);
        }
        return;
      }

      if (this.selectedRow && this.selectedRow.id === row.id) {
        this.selectedRow = row;
        this.$emit("row-clicked", row);
        return;
      }
      // When check_codigo_barra is enabled, validate only the currently selected row.
      if (this.check_codigo_barra && Object.keys(this.selectedRow).length > 0) {
        if (this.checkCodigoBarra(this.selectedRow)) {
          this.$emit("codigo-barra-error");
          return;
        }
      }

      // If there is no old selection or the old selection is valid, update to the new row.
      this.selectedRow = row;
      this.$emit("row-clicked", row);
    },
    checkCodigoBarra(item) {
      const validStatuses = ["ativo", "fechado"];
      // If the item is empty or its status isn’t one of the valid ones, skip the check.
      if (
        Object.keys(item).length === 0 ||
        !validStatuses.includes(item.status)
      ) {
        return false;
      }
      // Check if Código de Barras is null, empty, or "N/A"
      if (
        !item.CodigoBarra ||
        item.CodigoBarra.trim() === "" ||
        item.CodigoBarra === "N/A"
      ) {
        return true;
      }
      return false;
    },

    criarServico() {
      this.$emit("criar-servico");
    },
    criarObservacao() {
      this.$emit("criar-observacao");
    },
    delete_onClick(row) {
      this.$emit("delete_data", row);
    },
    close() {
      this.$store.state.clientes.showRightForm = true;
      this.$emit("close");
    },
    addTrueValues(obj) {
      let newObj = {};
      for (let key in obj) {
        newObj[key] = true;
      }
      return newObj;
    },
    updateFilter({ property, value }) {
      this.filter_data[property] = value;
    },
    getSearch(text) {
      this.search_text = text;
    },
    applySearchFilter(data) {
      if (!this.search_text) {
        return data;
      }
      return data.filter((row) => {
        for (let key in row) {
          if (
            Object.prototype.hasOwnProperty.call(row, key) &&
            typeof row[key] === "string" &&
            row[key].toLowerCase().includes(this.search_text.toLowerCase())
          ) {
            return true;
          } else if (
            Object.prototype.hasOwnProperty.call(row, key) &&
            typeof row[key] === "number" &&
            row[key] == parseInt(this.search_text)
          ) {
            return true;
          }
        }
        return false;
      });
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    showConfirm(event, row) {
      console.log("event", event);
      // check if row is a button(string) click or a row click
      if(this.isMultiSelect){
        console.log("Confirmed multi!");
        this.$refs.myConfirm.show(event.target);
        return;
      }
      this.selectedRow = row;
      this.$refs.myConfirm.show(event.target);
    },
    onAccept() {
      // if (this.isMultiSelect) {
      //   this.sendSelectedRows();
      //   return;
      // }
      this.handleRowClick(this.selectedRow);
    },
    AcceptOne() {
      console.log("Confirmed one!");
      const permissoes = 1;
      this.handleRowClick(this.selectedRow, permissoes);
    },
    onAcceptBoth() {
      console.log("Confirmed both!");
      const permissoes = 2;
      this.handleRowClick(this.selectedRow, permissoes);
    },
    confirmInclude() {
      if (this.confirmationProps.show) {
        return true;
      }
      return false;
    },
    isSelectedRow(row) {
      if (this.isMultiSelect) {
        return this.selectedRows.some(
          (selectedRow) => selectedRow.id === row.id
        );
      }
      return this.selectedRow.id === row.id;
    },
    sendSelectedRows(emit_type) {
      console.log("selected rows:", this.selectedRows);
      this.$emit(
       emit_type,
        this.selectedRows.sort((a, b) => a.id - b.id)
      );
    },
    handleAcaoClick(emitType, row) {
      this.$emit(emitType, row);
    },

    getBackgroundColor(row) {
      // 1. Selected row: keep it the same.
      if (this.isSelectedRow(row)) {
        return "#ff9b05";
      }

      // 2. If override is active, try to find the row in rowStatusData.
      if (this.applyRowStatusColors) {
        const statusEntry = this.rowStatusData.find(
          (entry) => entry.id === row.id
        );
        if (statusEntry) {
          // Handle the different statuses:
          switch (statusEntry.status) {
            case "rejeitado":
              return "red"; // override with red for "rejeitado"
            case "local":
              return "#3498db"; // override with a suggestion color (blue, for example)
            // For "ativo", let it fall back to the default styling.
            case "fechado":
              return "var(--verde-claro)";
            case "cancelado":
              return "var(--vermelho-2)";
            case "substituido":
              return "red";
            default:
              break;
          }
        }
      }

      // 3. Default logic (existing row.status based colors)
      if (row.status === "desativado") {
        return "var(--vermelho-2)";
      } else if (row.status === "fechado") {
        return "var(--verde-claro)";
      } else {
        return row.cor ? row.cor : "";
      }
    },
  },
  computed: {
    perPageOptions() {
      return [5, 10, 15, 20];
    },
    filteredTableData() {
      // Copy table_data (or filter/format as needed)
      return this.table_data.map((row) => {
        let filteredRow = {};
        // In this case, we assume filter_data has all keys set to true
        for (let key in row) {
          if (this.filter_data[key]) {
            filteredRow[key] = row[key];
          }
        }
        return filteredRow;
      });
    },
    displayedHeaders() {
      // Make sure table_data has at least one object
      if (this.filteredTableData.length > 0) {
        return Object.keys(this.filteredTableData[0]).filter(
          (key) => !this.hiddenHeaders.includes(key)
        );
      }
      return [];
    },
    searchedTableData() {
      return this.applySearchFilter(this.filteredTableData);
    },
    totalPages() {
      return Math.ceil(this.searchedTableData.length / this.perPage);
    },
    displayedTableData() {
      const startIndex = (this.currentPage - 1) * this.perPage;
      const endIndex = startIndex + this.perPage;
      return this.searchedTableData.slice(startIndex, endIndex);
    },
    mergedTableData() {
      const mergedData = [];
      const filteredData = this.filteredTableData;
      const displayedData = this.displayedTableData;
      if (filteredData && filteredData.length > 0) {
        const filteredKeys = Object.keys(filteredData[0]);
        for (let i = 0; i < displayedData.length; i++) {
          const row = displayedData[i];
          const mergedRow = {};
          for (const key of filteredKeys) {
            mergedRow[key] = row[key];
          }
          mergedData.push(mergedRow);
        }
      }
      return mergedData;
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Inter&family=Montserrat:wght@600&family=Poppins:wght@600&display=swap");

.table_wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background-color: rgba(89, 89, 152, 0.45);
  padding: 2rem;
  border-radius: 8px;
  justify-content: flex-start;
  align-items: center;
  color: white;
  overflow-x: auto;
}

.title_table {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.title_settings {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.table_title {
  font-size: 16px;
  color: var(--titulo);
}

.close_btn_div {
  display: flex;
  align-self: flex-end;
  justify-content: center;
  align-items: center;
  gap: 0.3rem;
}

.table_r table {
  color: var(--label);
  table-layout: fixed;
  width: 100%;
  max-height: 253px;
  overflow-y: auto;
  overflow-x: auto;
  gap: 1rem;
  border-collapse: separate;
  border-spacing: 0 0.3em;
}

thead {
  background-color: var(--colunaLista);
  width: 100%;
  height: 25px;
  border-radius: 8px;
}

th {
  font-size: 14px;
  text-align: left;
  padding-left: 0.5rem;
  text-transform: capitalize;
  font-weight: 400;
}

tbody {
  width: 100%;
}

tbody tr {
  height: 25px;
  cursor: pointer;
  margin-bottom: 1em;
}

tbody tr:hover td {
  background: #c67700;
}

.nonselected td {
  background-color: var(--linhaLista);
  font-size: 10px;
  text-align: left;
  padding-left: 0.5rem;
  border: none;
}

.selected td {
  background-color: #ff9b05;
  font-size: 10px;
  text-align: left;
  padding-left: 0.5rem;
  border: none;
}

td:first-child,
th:first-child {
  border-radius: 8px 0 0 8px;
}

td:last-child,
th:last-child {
  border-radius: 0 8px 8px 0;
}

th,
td {
  max-width: 200px; 
}

.truncate-cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px; 
}

.wrap-cell {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}


@media (max-width: 768px) {
  .table_wrapper {
    font-size: 0.8em;
  }
}

@media (min-width: 769px) {
  .table_wrapper {
    font-size: 1em;
  }
}
</style>
